import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { unitResource } from './../../underwritingManage/request';
import { agencyResource } from './../../organizationalManage/request';
import { intermediaryResource } from './../../agencyManage/request';
import { uploadFile } from '@/views/customer/applicationManage/request';
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
import { cryptoDecrypt } from '@/utils/aes';
import { COLUMNSLIST } from './utils';
import { addAttach, editAttach, attachDetail, addInsuranceTerms, insuranceTermsResource } from './../request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import termsModel from '@/views/insurance/insuranceManage/components/termsModel.vue';
export default {
  components: {
    topTitle,
    quillEditor,
    termsModel
  },
  props: {
    id: {
      type: Number,
      default: -1,
      required: true
    }
  },
  data() {
    return {
      unitList: [],
      agencyList: [],
      intermediaryList: [],
      dataForm: {
        name: '',
        description: '',
        recordNumber: '',
        recordName: '',
        unitId: undefined,
        agencyId: undefined,
        intermediaryId: undefined,
        isFile: 0,
        insuranceTermsId: ''
      },
      checked: false,
      termsForm: {
        name: '',
        linkName: '',
        content: '',
        link: ''
      },
      uploadFile,
      quillOption: quillConfig,
      tableData: [],
      COLUMNSLIST,
      disabled: true,
      termsShow: false,
      delArr: [],
      saveLoading: false,
      saveTermsLoading: false,
      fileList: [],
      uploadStatus: false
    };
  },
  computed: {
    DATARULE() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('产品名称'),
          trigger: 'blur'
        }, {
          min: 5,
          message: this.$t('至少输入5个字符'),
          trigger: 'blur'
        }, {
          max: 50,
          message: this.$t('最多输入50字符'),
          trigger: 'blur'
        }],
        unitId: [{
          required: true,
          message: this.$t('请选择') + this.$t('承保单位'),
          trigger: 'change'
        }],
        agencyId: [{
          required: true,
          message: this.$t('请选择') + this.$t('承保机构'),
          trigger: 'change'
        }],
        recordNumber: [{
          required: false,
          max: 50,
          message: this.$t('最多输入50字符'),
          trigger: 'blur'
        }],
        recordName: [{
          required: false,
          max: 50,
          message: this.$t('最多输入50字符'),
          trigger: 'blur'
        }],
        code: [{
          required: false,
          max: 30,
          message: this.$t('最多输入30字符'),
          trigger: 'blur'
        }],
        description: [{
          required: false,
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'blur'
        }]
      };
    },
    TERMRULE() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('产品名称'),
          trigger: 'blur'
        }, {
          min: 5,
          message: this.$t('至少输入5个字符'),
          trigger: 'blur'
        }, {
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'blur'
        }],
        linkName: [{
          required: true,
          message: this.$t('请上传条款文件'),
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('文本内容'),
          trigger: 'change'
        }]
      };
    }
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
    });
    intermediaryResource({}).then(res => {
      this.intermediaryList = res;
    });
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.id);
      if (this.id != -1) {
        this.getInfo();
      }
    });
  },
  methods: {
    async getInfo() {
      this.dataForm = await attachDetail({
        insuranceAttachId: this.id
      });
      if (this.dataForm.intermediaryId == 0) {
        this.dataForm.intermediaryId = undefined;
      }
      this.dataForm.insuranceAttachId = this.id;
      this.tableData = this.dataForm.termsList;
      this.checked = this.dataForm.isFile ? false : true;
      if (!this.checked) {
        if (this.tableData.length == 0) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      } else {
        this.disabled = false;
      }
      if (!this.$store.state.user.accountInfo.customerId) {
        await this.countryAndCurrencyInfo(this.dataForm.agencyId, 'agencyId');
      }
      this.agencyFun();
    },
    onChange(val) {
      this.agencyList = [];
      this.dataForm.agencyId = undefined;
      if (val) {
        this.agencyFun();
      }
    },
    onPreview(val) {
      window.open(val.link);
    },
    agencyFun() {
      agencyResource({
        unitId: this.dataForm.unitId
      }).then(res => {
        this.agencyList = res;
      });
    },
    changeChecked() {
      if (this.uploadStatus) {
        return this.$message.error(this.$t('文件上传中,禁止点击操作'));
      }
      this.checked = !this.checked;
      if (!this.checked) {
        if (this.tableData.length == 0) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      } else {
        this.disabled = false;
      }
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'application/pdf';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请上传正确的文件格式,例如:pdf'));
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(this.$t('文件过大，请选择5M以下文件上传'));
      }
      return isJpgOrPng && isLt5M;
    },
    handleChange({
      file,
      fileList
    }) {
      if (!file.status) {
        return false;
      }
      this.uploadStatus = true;
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
      const fileArr = fileList.length != 0 ? [fileList[fileList.length - 1]] : [];
      this.fileList = fileArr;
      if (file.status === 'done') {
        this.$message.success(`${file.name} ` + this.$t('上传成功'));
        this.uploadStatus = false;
      } else if (file.status === 'error') {
        this.$message.error(`${file.name} ` + this.$t('上传失败'));
        this.uploadStatus = false;
      }
      if (fileArr.length != 0 && fileArr[0].url) {
        this.termsForm.linkName = fileArr.length != 0 ? fileArr[0].name : '';
        this.termsForm.link = fileArr.length != 0 ? fileArr[0].url : '';
      }
    },
    addTermsFun() {
      if (this.uploadStatus) {
        return this.$message.error(this.$t('文件上传中,等待上传完成再添加'));
      }
      this.$refs.termsRef.validate(async valid => {
        if (valid) {
          this.saveTermsLoading = true;
          const res = await addInsuranceTerms(Object.assign(recursionCopy(this.termsForm), {
            type: 2
          }));
          const res2 = await insuranceTermsResource({
            insuranceTermsId: res.termsId
          });
          this.$message.success(this.$t('添加成功') + '!');
          const obj = recursionCopy(this.termsForm);
          obj.link = res2[0].link;
          this.tableData.push(Object.assign(obj, {
            insuranceTermsId: res.termsId,
            id: res.termsId
          }));
          if (!this.checked) {
            if (this.tableData.length == 0) {
              this.disabled = true;
            } else {
              this.disabled = false;
            }
          } else {
            this.disabled = false;
          }
          setTimeout(() => {
            this.fileList = [];
            this.saveTermsLoading = false;
            this.$refs['termsRef'].resetFields();
            this.termsForm = {
              name: '',
              linkName: '',
              content: '',
              link: ''
            };
          }, 400);
        }
      });
    },
    nextFun() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          this.saveLoading = true;
          if (this.tableData.length != 0 && !this.checked) {
            const arr = this.tableData.map(item => {
              return item.id;
            });
            this.dataForm.insuranceTermsId = arr.join(',');
          } else {
            this.dataForm.insuranceTermsId = '';
          }
          this.dataForm.isFile = this.checked ? 0 : 1;
          this.dataForm.deleteInsuranceTermsId = this.delArr;
          this.dataForm.termsList = this.tableData;
          console.log(this.dataForm);
          const FUN = this.id != -1 ? editAttach : addAttach;
          const res = await FUN(this.dataForm);
          this.saveLoading = false;
          if (res.code != 200) {
            return this.$message.error(this.$t(res.message));
          }
          this.dataForm.insuranceAttachId = res.insuranceAttachId;
          this.$message.success(this.$t('操作成功') + '!');
          this.$emit('next', res.data);
        }
      });
    },
    async handleDelete(val, index) {
      this.delArr.push(this.tableData[index].id);
      this.tableData.splice(index, 1);
      if (!this.checked) {
        if (this.tableData.length == 0) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      } else {
        this.disabled = false;
      }
    },
    handleEdit(val, index) {
      this.termsShow = true;
      this.$nextTick(() => {
        this.$refs.termsRef2.init(recursionCopy(val), index, 2);
      });
    },
    updateTermsFun(val, index) {
      this.tableData.splice(index, 1, val);
      console.log(this.tableData);
    },
    async onAgencyChange(val) {
      if (!val) {
        this.dataForm.unitId = undefined;
        this.agencyList = [];
      } else {
        if (!this.$store.state.user.accountInfo.customerId) {
          await this.countryAndCurrencyInfo(this.dataForm.agencyId, 'agencyId');
        }
      }
    }
  }
};